import { AuthActions, AuthActionTypes } from '../actions';
import { User } from '../../models';
import { AppLocalStorage } from '../../helpers';

export interface State {
  loggedIn: boolean;
  user: User | null;
}

export const initialState: State = {
  loggedIn: !!AppLocalStorage.authToken,
  user:  null,
};

export function reducer(state = initialState, action: AuthActions): State {
  switch (action.type) {
    case AuthActionTypes.LoginSuccess: {
      return {
        ...state,
        loggedIn: true,       
        user: action.payload.user,
      };
    }

    case AuthActionTypes.LoadUserSuccess: {
      return {
        ...state,
        user: action.payload,
      };
    }

    case AuthActionTypes.Logout: 
    case AuthActionTypes.LoginRedirect: {
      return {
        ...state,
        loggedIn: false,
        user: null,
      }
    }
    default: {
      return state;
    }
  }
}

export const getLoggedIn = (state: State) => state.loggedIn;
export const getLoggedInUser = (state: State) => state.user;
export const getLoggedInUserPermissions = (state: State) => state.user && (state.user.permissions || []);
export const getLoggedInUserRoles = (state: State) => state.user && (state.user.roles || []);



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/auth.reducers.ts